module.exports = __webpack_public_path__ + "img/blankHorizonsWhite.f43130fb.svg";